import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../navigators/NavigationProp';

import New, {
  DispatchProps,
  StateProps,
} from '../../../components/story_form/image/New';

import AppState from '../../../reducers/AppState';

import createStory, {
  Params as StoryCreateParams,
} from '../../../actions/stories/create';
import updateStoryForm, {
  Params as StoryFormUpdateParams,
} from '../../../actions/story_forms/update';

interface Props {
  navigation: NavigationProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation} = props;
  const {forms} = state;
  const storyForm = forms.storyForm;
  return {
    navigation,
    storyForm,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    createStory: (params: StoryCreateParams) => dispatch(createStory(params)),
    updateStoryForm: (params: StoryFormUpdateParams) =>
      dispatch(updateStoryForm(params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(New);
